import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useMe, useLogout } from './lib/auth.js';
import { useCart } from './lib/cart.js';

export function Layout(): JSX.Element {
  const me = useMe();
  const logout = useLogout();
  const cart = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const onLogout = async () => {
    await logout.mutateAsync();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            Z9 Security Shop
          </Link>
          <nav className="flex items-center gap-4 text-sm">
            <Link to="/" className="text-slate-700 hover:text-slate-900">
              Catalog
            </Link>
            <Link to="/orders" className="text-slate-700 hover:text-slate-900">
              Orders
            </Link>
            <Link to="/licenses" className="text-slate-700 hover:text-slate-900">
              Licenses
            </Link>
            <Link to="/downloads" className="text-slate-700 hover:text-slate-900">
              Downloads
            </Link>
            <Link to="/cart" className="flex items-center gap-1 text-slate-700 hover:text-slate-900" data-testid="cart-link">
              Cart
              {cart.count > 0 ? (
                <span data-testid="cart-count" className="inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-slate-900 px-1.5 text-xs text-white">
                  {cart.count}
                </span>
              ) : null}
            </Link>
            {me.isLoading ? (
              <span className="text-slate-400">...</span>
            ) : me.data ? (
              <>
                <span data-testid="me-email" className="text-slate-500">
                  {me.data.email}
                </span>
                <button
                  type="button"
                  onClick={onLogout}
                  className="rounded border border-slate-300 px-3 py-1 text-slate-700 hover:bg-slate-100"
                >
                  Sign out
                </button>
              </>
            ) : (
              <Link
                to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`}
                className="rounded bg-slate-900 px-3 py-1 text-white hover:bg-slate-800"
              >
                Sign in
              </Link>
            )}
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
